module.exports = __webpack_public_path__ + "img/topgun.d1e92f69.jpg";